// extracted by mini-css-extract-plugin
export default {"cls1":"H2uOo08j1oRmDB2B5fIm","cls2":"apKXy2VUWAw7XV4WsEvP H2uOo08j1oRmDB2B5fIm"};